/*
 *
 * Package: `@dbh/text-with-icon-theme`.
 *
 */const TEXT_WITH_ICON_THEME_KEY="textWithIcon";const modifyTextWithIconTheme=a=>{let{fonts:{lineHeight:{l2:c}},spacing:{sp2:b}}=a;return {[TEXT_WITH_ICON_THEME_KEY]:{iconMargin:"0 "+b+" 0 0",lineHeight:c}}};

export { TEXT_WITH_ICON_THEME_KEY, modifyTextWithIconTheme as default };
